import { defineMessages, IntlShape } from "react-intl";

const messages = defineMessages({
  comboOrderModalMessageItemsAnd: {
    id: "comboOrderModalMessageItemsAnd",
    defaultMessage: "and",
  },
});

export const getReadableComboOrderTestTypesString = (
  testTypes: string[],
  intl: IntlShape
): string => {
  //handle empty array or empty string in array
  if (
    testTypes.length === 0 ||
    (testTypes.length === 1 && testTypes[0] === "")
  ) {
    return "";
  }

  //handle single item in array
  if (testTypes.length === 1) {
    return testTypes[0];
  }

  return (
    testTypes.slice(0, -1).join(", ") +
    ` ${intl.formatMessage(messages.comboOrderModalMessageItemsAnd)} ` +
    testTypes.slice(-1)
  );
};
